export const GAME_TITLE = 'நவில்'
export const ENTER_TEXT = 'சரிபார்'
export const HOW_TO_PLAY = 'விதிகள்'
export const FIND_WORDS  = 'மறைந்துள்ள சொல்லை 8 முயற்சிகளில் கண்டுபிடிக்க.'
export const FILL_WORDS  = 'ஏதாவது  ஒரு  சொல்லை  நிரப்பி  சரிபார்  Key ஐ அமுக்கவும்'
export const COLOR_NOTES_LETTERS = 'கீழ்  வரும்  குறிப்புகளின்  உதவியால்  இன்றைய  வார்த்தையை  கண்டு  பிடிக்கவும்'
export const COLOR_NOTES = 'குறிப்புக்கள்'
export const LETTER_CORRECT_PLACE = 'எழுத்து தெ சொல்லின் சரியான இடத்தில் உள்ளது.'
export const LETTER_CHANGE_PLACE = 'எழுத்து ன் சொல்லில் உள்ளது அனால் வேறு இடத்தில் உள்ளது.'
export const LETTER_NOPE = 'எழுத்து ம் சொல்லில் எங்கும் இடம்பெறவில்லை.'
export const ANOTHER_LETTER_RA_IS_HERE = 'எழுத்து ர் சொல்லில் இடம்பெறவில்லை தவிர ரகர வரிசையில் வேறு ஏதோ எழுத்து (ரா, ரி , ரீ, ரு, ...) இதே இடத்தில் இடம்பெற்றுள்ளது.'
export const ANOTHER_LETTER_KA_IS_HERE = 'எழுத்து கி சொல்லில் இடம்பெறவில்லை தவிர ககர வரிசையில் வேறு ஏதோ எழுத்து (க், க, கா, கு, ...) வேறு இடத்தில் இடம்பெற்றுள்ளது.'
export const ANOTHER_LETTER_RAKA_IS_HERE = 'எழுத்து ற் சொல்லில் வேறு இடத்தில் உள்ளது, அதோடு ற் உள்ள இடத்தில் வேறு றகர வரிசையும் இடம்பெற்றுள்ளது.'
export const SETTINGS_NAME = 'அமைப்பு'
export const UYIRE_MEI_NOTES = 'உயிர் மற்றும் மெய் குறிப்பு'
export const UYIRE_MEI_DESCRIPTION = 'உயிர் எழுத்தோ அல்லது மெய் எழுத்தோ பொருந்தி இருப்பதை குறிக்கும்'
export const EASY_MODE = 'எளிய முறை'
export const EASY_MODE_DESCRIPTION = 'உயிர்மெய் எழுத்தின் மெய்யெழுத்து பகுதி சரி எனில், உயிர்மெய் எழுத்தாக தானாக மாறும்'
export const EASY_MODE_DESCRIPTION_TWO = '(எ.கா : னை வரவேண்டிய இடத்தில் ன இருந்தால், தானாக னை -ஆக மாறும்)'
export const DARK_MODE = 'கருப்பு திரை'
export const DARK_MODE_DESCRIPTION = 'Dark Theme'
export const DICTIONARY = 'அகராதியில் இல்லாத சொல்லையும் அனுமதிக்க'
export const DICTIONARY_DESCRIPTION = 'Skip Dictionary Validation'
export const FEEDBACK = 'கருத்து தெரிவிக்க'
export const FEEDBACK_DESCRIPTION = 'Feedback'